import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const departments = [
    { name: "परिचय ", key: "about" },
    { name: "संचालित पाठ्यक्रम", key: "courses" },
    { name: "संकाय सदस्य", key: "faculty" },
    { name: "समय सारिणी", key: "timetable" },
    { name: "सुविधाएं", key: "facilities" },
    { name: "सेमीनार/सम्मेलन/कार्यशाला", key: "events" },
    { name: "शोध छात्र", key: "researchScholars" },
    { name: "उपलब्धियां", key: "achievements" },
    { name: "सम्पर्क", key: "contact" }
];

// Content for each section, structured as an object with improved spacing
const departmentContent = {
    about: (
        <div className="mb-4"> {/* Added margin-bottom for the whole section */}
            <h4
                className="mb-3 text-center"
                style={{ color: "#77236b" }}
            >
                वेद विभाग
            </h4>
            <p className="mb-3">प्राच्यविद्या एवं संस्कृति को समृद्ध करने की दिशा में महर्षि वाल्मीकि संस्कृत विश्वविद्यालय के वेदविभाग 2018 से ही अक्षुण्ण योगदान देता आ रहा है। इस विभाग में मुख्यतः शुक्लयजुर्वेद विषय के शिक्षण की सम्यक् व्यवस्था के साथ – साथ कर्मकाण्ड विषयक सैद्धान्तिक एवं प्रायोगिक प्रशिक्षण की सुदृढ व्यवस्था है। प्राच्य विद्या के अन्तर्गत वेद, वेदाङ्ग, ब्राह्मण, श्रौतसूत्र, आरण्यक आदि विषयों के अध्यापन द्वारा छात्रों को वैषयिक एवं प्रायोगिक ज्ञान प्रदान किया जाता है। विभाग में अध्ययनरत छात्र एवं छात्राओं को अधोलिखित उद्देश्यपरक अध्यापन करवाया जाता है।</p>
            <ol className="mb-4"> {/* Margin for the list */}
                <li className="mb-2">आचार्य एवं शोध विषय के छात्रों को वैदिक यज्ञशाला में यज्ञपात्रों के परिचायात्मक ज्ञान के साथ – साथ श्रौत एवं स्मार्त्त यज्ञों के सम्बन्ध में विस्तृत प्रशिक्षण दिया जाता है।</li>
                <li className="mb-2">शोध के छात्रों को वैश्विक समस्याओं से सन्दर्भित पर्यावरण एवं प्रदूषण निवारण हेतु वैदिक समाधान का अनुसन्धानात्मक कार्य कराया जाता है।</li>
                <li className="mb-2">वैदिक कालीन भारतवर्ष का ज्ञान करवाना।</li>
                <li className="mb-2">सूक्तों में समाहित विविध ज्ञान-विज्ञान को अवगत करवाना।</li>
                <li className="mb-2">मीमांसा के माध्यम से विचार एवं तर्कशास्त्र का ज्ञान करवाना।</li>
                <li className="mb-2">वैदिक आचार विचार का ज्ञान देना।</li>
                <li className="mb-2">वैदिक चिकित्साप्रणाली, मनोचिकित्साप्रणाली का ज्ञान देना।</li>
                <li className="mb-2">वैदिककालीन विविधवृत्युपार्जन।</li>
                <li className="mb-2">वैदिक प्रशासन का ज्ञान।</li>
                <li className="mb-2">वैदिकराष्ट्र व राज्यकल्पना।</li>
                <li className="mb-2">प्राकृतिक कृषि पर वल देना।</li>
                <li className="mb-2">स्वरशास्त्रों का वैज्ञानिक विवेचन।</li>
                <li className="mb-2">संस्कारों का वैज्ञानिक ज्ञान करवाना।</li>
                <li className="mb-2">वृष्टिविज्ञान से सम्बन्धित ज्ञान करवाना।</li>
                <li>अग्निहोत्रादि से कृषि, पर्यावरण, फिजिक्स, इत्यादि विषयों पर परने वाला प्रभाव व विभिन्न विषयों के साथ सामांजस्य का ज्ञान करवाना जो इस विभाग के वैशिष्ट्य को दर्शाता है।</li>
            </ol>
            <p className="mb-3">भारतीय अस्मिता का आधारात्मक दर्शन मात्र वेद से है अतः वेद अध्ययन अनिवार्य है। समस्त ज्ञान की प्रस्तावना का आद्या उपन्यास वेद मात्र है अतः वेद का निष्कारण अध्ययन ऋषियों के द्वारा उक्त है। भारतीय सभ्यता संस्कृति संस्कार का स्रोत वैदिक वाङ्मय है अतः वैदिक ज्ञान परंपरा अनुशीलनीय है। विश्व के समस्त समस्याओं का शाश्वत निदान अगर मनुष्य और विज्ञान चाहता है तो उस समस्या के समाधान का अनुशीलन मात्र वेद विहित पद्धति ही है अतः वेद पाठ्य है। प्रविधि जनित मनसविकार, संक्रमित विभिन्न रोग समाधान हेतु रक्षण तंत्र एवं पर्यावरण परितंत्र विकास हेतु जिस पद्धति का अनुसरण अंतिम विकल्प है उस पद्धति का प्रतिपादक ग्रंथ वेद है अतः यह अध्येय है। संतुलित समग्रता का अध्ययन अगर अपेक्षित है तो बिना वेद के नहीं हो सकता आता है यह पाठ्य है। ईस्ट प्रति अनिष्ट निवारण धर्म अर्थ काम मोक्ष प्राप्ति हेतु मात्र एक राज पद्धति वेद है अतः यह अनुसंधेय है।</p>
        </div>
    ),
    courses: (
        <div className="mb-4">
            <h4 className="mb-3 text-center"
                style={{ color: "#77236b" }}
            >संचालित पाठ्यक्रम</h4>
            <ul className="list-unstyled"> {/* Using list-unstyled for custom spacing, if needed */}
                <li className="mb-2"><i className="bi bi-dot"></i> शास्त्री (वेद)</li> {/* Example of using Bootstrap Icons for bullet points */}
                <li className="mb-2"><i className="bi bi-dot"></i> आचार्य (वेद)</li>
                <li className="mb-2"><i className="bi bi-dot"></i> विद्यावारिधि</li>
            </ul>
        </div>
    ),
    faculty: (
        <div className="mb-5">
            <h4 className="mb-3 text-center"
                style={{ color: "#77236b" }}
            >संकाय सदस्य</h4>
            <div className="table-responsive">
                <table className="table table-bordered align-middle shadow-sm rounded">
                    <thead className="table-primary text-center">
                        <tr>
                            <th>Photo</th>
                            <th>Name</th>
                            <th>Designation</th>
                            <th>Qualification</th>
                            <th>Contact</th>
                            <th>Email</th>
                        </tr>
                    </thead>
                    <tbody className="text-center">
                        <tr>
                            <td style={{ width: "160px" }}>
                                <img
                                    src={require("../assets/Photos/डॉ. अखिलेश कुमार मिश्र, विभागाध्यक्ष (वेद).jpg")}
                                    alt="Dr. Akhilesh Kumar Mishra"
                                    className="img-fluid rounded"
                                    style={{ height: "120px", objectFit: "cover" }}
                                />
                            </td>
                            <td>डॉ. अखिलेश कुमार मिश्र</td>
                            <td>विभागाध्यक्ष, सहायक-आचार्य</td>
                            <td>पीएच.डी., नेट</td>
                            <td>7631274367</td>
                            <td><a href="mailto:hodved@mvsu.ac.in">hodved@mvsu.ac.in</a></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    ),


    timetable: (
        <div className="mb-4">
            <h4 className="mb-3 text-center"
                style={{ color: "#77236b" }}
            >समय सारिणी</h4>
            <p className="text-muted">समय सारिणी शीघ्र उपलब्ध होगी।</p>

        </div>
    ),
    facilities: (
        <div className="mb-4">
            <h4 className="mb-3 text-center"
                style={{ color: "#77236b" }}
            >सुविधाएं</h4>
            <ol className="mb-3">
                <li className="mb-2">छात्रों को वैषयिक ज्ञान के साथ प्रायोगिक ज्ञान प्रदान किया जाता है।</li>
                <li className="mb-2">विविध प्रतियोगी परीक्षाओं का प्रशिक्षण प्रदान किया जाता है, जैसे – यू.जी.सी. नेट परीक्षा, CTET, B.Ed., T.G.T (Sanskrit), P.G.T (Sanskrit), धर्मगुरु हेतु प्रशिक्षण इत्यादि।</li>
            </ol>
        </div>
    ),
    events: (
        <div className="mb-4">
            <h4 className="mb-3 text-center"
                style={{ color: "#77236b" }}
            >सेमीनार/सम्मेलन/कार्यशाला</h4>

            <h5 className="mt-4 mb-3 text-secondary">व्याख्यान:</h5> {/* Secondary color for sub-heading */}
            <div className="table-responsive mb-4">
                <table className="table table-bordered table-striped table-sm"> {/* table-sm for more compact table */}
                    <thead className="table-light">
                        <tr>
                            <th scope="col">व्याख्यानकर्त्ता/आधारपुरुष</th>
                            <th scope="col">कार्यक्रम</th>
                            <th scope="col">दिनाङ्क</th>
                            <th scope="col">विषय</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>डॉ.अखिलेश कुमार मिश्र</td>
                            <td>व्याख्यान</td>
                            <td>27.09.2021</td>
                            <td>वेदों में सन्निहित ज्ञान-विज्ञान की आधुनिक समय में उपयोगिता</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <h5 className="mb-3 text-secondary">वेद विभाग द्वारा राष्ट्रीय संगोष्ठी का आयोजन:</h5>
            <ul className="list-unstyled mb-4">
                <li className="mb-1"><strong>दिनाङ्क:</strong> 28/03/2022 (एक दिवसीय अन्तर्जालीय राष्ट्रीय संगोष्ठी)</li>
                <li className="mb-1"><strong>विषय:</strong> आधुनिकसमये वेदानां प्रासङ्गिकता।</li>
                <li className="mb-1"><strong>मुख्यातिथि:</strong> प्रो.देवनारायण झा, पूर्वकुलपति, का.सिं.द.संस्कृत विश्वविद्यालय।</li>
                <li className="mb-1"><strong>वक्ता:</strong>
                    <ol className="list-unstyled ms-3"> {/* Indent the inner list */}
                        <li><i className="bi bi-person-fill"></i> प्रो. रवि प्रकाश आर्य</li>
                        <li><i className="bi bi-person-fill"></i> डॉ. सुन्दर नारायण झा</li>
                        <li><i className="bi bi-person-fill"></i> डॉ. डी. दयानाथ</li>
                    </ol>
                </li>
            </ul>

            <h5 className="mb-3 text-secondary">अल्पावधि ग्रीष्मकालीन पाठ्यक्रम का आयोजन:</h5>
            <p className="mb-3">विभाग द्वारा दिनांक 27-06-2023 से 24-07-2023 तक 28 दिवसीय प्रायोगिक कर्मकाण्ड प्रशिक्षण का आयोजन करवाया गया।</p>
        </div>
    ),
    researchScholars: (
        <div className="mb-4">
            <h4 className="mb-3 text-center"
                style={{ color: "#77236b" }}
            >शोध छात्र</h4>
            <h5 className="mb-3 text-secondary">विद्यावारिधि उपाधि हेतु पंजीकृत छात्रों की विवरणी:</h5>
            <div className="table-responsive">
                <table className="table table-bordered table-striped table-hover align-middle">
                    <thead className="table-dark">
                        <tr>
                            <th scope="col">गवेषक</th>
                            <th scope="col">पर्यवेक्षक</th>
                            <th scope="col">विषय</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>वर्षा</td>
                            <td>डॉ. अखिलेश कुमार मिश्र</td>
                            <td>पर्यावरणशुद्धयर्थं श्रौतयागोपयुक्तवनस्पतीना-मनुशीलनात्मकमध्ययनम्।</td>
                        </tr>
                        <tr>
                            <td>प्रदीप कुमार</td>
                            <td>डॉ. अखिलेश कुमार मिश्र</td>
                            <td>नैतिमूल्योन्नयने गृह्यसूत्रवर्णितप्रमुखसंस्काराणां तात्त्विकमनुशीलनम्</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    ),
    achievements: (
        <div className="mb-4">
            <h4 className="mb-3 text-center"
                style={{ color: "#77236b" }}
            >उपलब्धियां</h4>
            <ul className="list-unstyled">
                <li className="mb-2"><i className="bi bi-award-fill text-warning me-2"></i> श्री रजत शर्मा, भारतीय सेना में धर्मगुरु पद पर कार्यरत (धर्मशिक्षक SCO 2022 से)</li>
                <li className="mb-2"><i className="bi bi-award-fill text-warning me-2"></i> श्री सन्दीप शर्मा, अंशकालीन सहायक आचार्य, महर्षि वाल्मीकि संस्कृत विश्वविद्यालय, कैथल (2023 से)</li>
                <li className="mb-2"><i className="bi bi-award-fill text-warning me-2"></i> श्री मुकेश शर्मा, लन्दन बुक ऑफ वर्ड में रिकार्ड (11050 squat)</li>
            </ul>
        </div>
    ),
    contact: (
        <div className="mb-4">
            <h4 className="mb-3 text-center"
                style={{ color: "#77236b" }}
            >सम्पर्क</h4>
            <p className="mb-1"><strong>डॉ. अखिलेश कुमार मिश्र</strong>, सहायक-आचार्य सह प्रभारी वेद</p>
            <p className="mb-1"><i className="bi bi-phone-fill me-2"></i> <strong>मोबाइल:</strong> 7631274367</p>
            <p><i className="bi bi-envelope-fill me-2"></i> <strong>ई-मेल:</strong> <a href="mailto:hodved@mvsu.ac.in">hodved@mvsu.ac.in</a></p>
        </div>
    )
};


export default function VedaDepartment() {
    const [showSidebar, setShowSidebar] = useState(true);
    const [activeIndex, setActiveIndex] = useState(0);

    const handleItemClick = (index) => {
        setActiveIndex(index);

        if (window.innerWidth < 768) {
            setShowSidebar(false);
        }
    };


    const activeDepartmentKey = departments[activeIndex].key;

    return (
        <div className="d-flex vh-100 flex-column flex-md-row bg-light">

            <button
                className="btn text-white fw-bold d-md-none m-2 rounded"
                style={{ backgroundColor: "#77236b", borderColor: "#77236b" }}
                onClick={() => setShowSidebar(!showSidebar)}
                aria-controls="university-sidebar"
                aria-expanded={showSidebar}
            >
                ☰ मेनू
            </button>

            <aside className={`bg-white text-dark p-3 shadow-lg d-flex flex-column ${showSidebar ? "d-block" : "d-none"} d-md-flex col-md-3 border-end`}>
                <h5 className="text-center fw-bold mb-4 text-dark border-bottom pb-2">वेद विभाग</h5>
                <div className="flex-grow-1 overflow-auto pe-2">
                    {departments.map((dept, index) => (
                        <p
                            key={dept.key}
                            className={`mb-2 p-2 rounded small cursor-pointer shadow-sm ${activeIndex === index ? "text-white" : "bg-light text-dark hover-effect"
                                }`}
                            onClick={() => handleItemClick(index)}
                            style={{
                                cursor: "pointer",
                                transition: "background-color 0.3s ease, color 0.3s ease",
                                backgroundColor: activeIndex === index ? "#77236b" : undefined,
                                fontWeight: activeIndex === index ? "bold" : "normal"
                            }}
                        >
                            {dept.name}
                        </p>

                    ))}
                </div>
            </aside>


            <main className="flex-grow-1 p-4 bg-white shadow col-md-9 overflow-auto">
                {departmentContent[activeDepartmentKey]}
            </main>


            <style jsx>{`
                .hover-effect:hover {
                    background-color: #e2e6ea !important; /* Lighter grey on hover */
                    color: #000 !important;
                }
            `}</style>
        </div>
    );
}